<template>
  <div class="restriktionen-segmented">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="restriktionen-segmented__segment"
      :class="{ 'restriktionen-segmented__segment--active': option.value === value }"
      @click="$emit('input', option.value)"
    >
      {{ option.text }}
    </button>
  </div>
</template>

<script>
// Umschalter im Segmented-Control-Stil, das aktive Segment wird als weißes Chip hervorgehoben
export default {
  name: 'RestriktionenSegmentedControlComponent',
  props: {
    options: { type: Array, default: () => [] },
    value: { type: [String, Number], default: null },
  },
};
</script>

<style scoped>
.restriktionen-segmented {
  display: flex;
  padding: 4px;
  background: var(--surface-sunken);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
}

.restriktionen-segmented__segment {
  flex: 1;
  height: var(--control-h-sm);
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  font-size: 12px;
  color: var(--text-body);
  cursor: pointer;
  white-space: nowrap;
}

.restriktionen-segmented__segment:hover {
  color: var(--text);
}

.restriktionen-segmented__segment--active {
  background: var(--surface);
  color: var(--text);
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  box-shadow: 0px 1px 2px 0px #0000001a;
  box-shadow: 0px 0px 0px 0px #0000000d;
}
</style>
